//Neighborhood Discovery Carousel Iniitalization
import "shared_non_critical/rdc_horizontal_carousel";
import {
  QUESTION_MARK
} from "shared_critical/constants/string";

const $neighborhoodCarousel = $("#nd-carousel"),
      $ndSearchCity = (MOVE_DATA.searchResults || {}).search_type === "city",
      $ndSearchNh = (MOVE_DATA.searchResults || {}).search_type === "neighborhood";

// Initialize ND Carousel
const initializeNeighborhoodCarousel = () => {
  $neighborhoodCarousel.RdcHorizontalCarousel({
    loop: false,
    showNav: "show",
    moveBy: "set",
    autoWidth: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    responsive: {
      0: {
        items: 1,
        autoWidth: true
      },
      996: {
        items: 6,
        autoWidth: true
      },
      1280: {
        items: 8,
        autoWidth: true
      }
    }
  });
};

if ($ndSearchNh || $ndSearchCity) {
  //Keep selected carousel element if there are no Neigborhood Suggestions (Initial Load)
  if ($neighborhoodCarousel.find(".owl-carousel .owl-item").length === 0) {
    $(".nd-selected-overlay").hide();
  }
  initializeNeighborhoodCarousel();
}

if (window.location.href.indexOf("view=nd") >= 0)
    initializeNeighborhoodCarousel();

$(".nd-carousel-open").off("click").on("click", function() {
    window.location.href += addNdParam(window.location.href);
  });

//Add view=nd param to URL to keep track of ND carousel
var addNdParam = function(url) {
  if (url.indexOf("view=nd") >= 0) return "";
  return url.indexOf(QUESTION_MARK) >= 0 ? "&view=nd" : "?view=nd";
};


//Set up carousel URL Rendering for filter integration
var renderCarouselURL = function () {
    let appendNdURL;
    var ndCarEl  = document.getElementsByClassName("nd-item-link-block"),
        widgEl   = document.getElementsByClassName("gi-nh-item");

    if (window.location.href.indexOf('?') >=0 )
      appendNdURL = window.location.href.split('/').slice(5).join("/").split('?').slice(0, -1);
    else
      appendNdURL = window.location.href.split('/').slice(5).join("/");
      
    renderNDURL(ndCarEl, appendNdURL);
    renderNDURL(widgEl, appendNdURL);
}

var renderNDURL = function (el, appendNdURL){
  for (var i = 0; i < el.length; i++) {
    if (el[i].href.indexOf('http') >= 0) {
      //after filters application, path changes becomes absolute, include this scenario
      el[i].href = el[i].href.split('?').slice(0,-1).join('/') + '/' + appendNdURL + '?view=nd';
    } else
      //on initial render, this is a relative path
      el[i].href = el[i].href.split('/').slice(0,-2).join('/') + '/' + appendNdURL + '?view=nd';
  }
}

//Initialize carousel for 'See All' param addition
window.onhashchange = function() {
  if (window.location.href.indexOf("view=nd") >= 0)
    initializeNeighborhoodCarousel();
};

// Detect URL Change for
// Changing URLs within Carousel during
// Filters Application
$(document).on('search::updated', () => setTimeout(renderCarouselURL, 700));
renderCarouselURL();


// WEBPACK FOOTER //
// ./srp/views/neighborhood_discovery/_nd_carousel_init.js